import { useTheme } from "@emotion/react";
import LanguageIcon from "@mui/icons-material/Language";
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { dropdownIcon, menuItem } from "../../styles/dropdownStyles";
import Dropdown from "./Dropdown";

const LanguageDropdown = ({ languages }) => {
  const { i18n, t } = useTranslation();
  const theme = useTheme();

  const changeLanguage = useCallback(
    (lang) => {
      i18n.changeLanguage(lang);
      localStorage.setItem("lang", lang);
    },
    [i18n]
  );

  return (
    <Dropdown
      icon={<LanguageIcon />}
      buttonProps={{
        color: "inherit",
        "aria-label": t(`changeLang`),
      }}
    >
      {languages.map((lang) => (
        <MenuItem key={lang.code} onClick={() => changeLanguage(lang.code)} sx={menuItem(theme)}>
          <ListItemIcon>
            <Box component="img" src={lang.icon} alt={lang.label} sx={dropdownIcon} />
          </ListItemIcon>
          <ListItemText primary={lang.label} />
        </MenuItem>
      ))}
    </Dropdown>
  );
};

export default LanguageDropdown;
